"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = MapWindow;

var _react = _interopRequireWildcard(require("react"));

var _classnames = _interopRequireDefault(require("classnames"));

var _MapWindowModule = _interopRequireDefault(require("./MapWindow.module.scss"));

var _WindowControls = _interopRequireDefault(require("../../WindowControls/WindowControls"));

var _Button = _interopRequireDefault(require("../../../inputElements/Button/Button"));

var _EButtonType = _interopRequireDefault(require("../../../inputElements/Button/EButtonType"));

var _inputElements = require("../../../inputElements");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

/*
TODO: Tooltips
- Show location markings.
- Hide location markings.
- Add location marking.
- Delete location marking.
*/
function MapWindow(_ref) {
  var _ref$className = _ref.className,
      className = _ref$className === void 0 ? "" : _ref$className,
      style = _ref.style;

  var _useState = (0, _react.useState)(-999),
      _useState2 = _slicedToArray(_useState, 1),
      coordNorth = _useState2[0];

  var _useState3 = (0, _react.useState)(-999),
      _useState4 = _slicedToArray(_useState3, 1),
      coordEast = _useState4[0];

  var _useState5 = (0, _react.useState)(""),
      _useState6 = _slicedToArray(_useState5, 2),
      pinText = _useState6[0],
      setPinText = _useState6[1];

  var _useState7 = (0, _react.useState)(true),
      _useState8 = _slicedToArray(_useState7, 2),
      pinsAreVisible = _useState8[0],
      setPinsAreVisible = _useState8[1];

  return /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _classnames.default)(_MapWindowModule.default.window, className),
    style: style
  }, /*#__PURE__*/_react.default.createElement(_WindowControls.default, {
    classNameCloseBtn: _MapWindowModule.default.closeBtn
    /* TODO: dragHandler */

  }), /*#__PURE__*/_react.default.createElement("div", {
    className: _MapWindowModule.default.map
  }), /*#__PURE__*/_react.default.createElement("div", {
    className: _MapWindowModule.default.footer
  }, !pinsAreVisible && /*#__PURE__*/_react.default.createElement(_Button.default, {
    type: _EButtonType.default.MM_PIN_SHOW,
    className: _MapWindowModule.default.showBtn,
    onClick: function onClick() {
      return setPinsAreVisible(true);
    }
  }), pinsAreVisible && /*#__PURE__*/_react.default.createElement(_Button.default, {
    type: _EButtonType.default.MM_PIN_HIDE,
    className: _MapWindowModule.default.hideBtn,
    onClick: function onClick() {
      return setPinsAreVisible(false);
    }
  }), /*#__PURE__*/_react.default.createElement(_inputElements.Input, {
    type: "text",
    value: coordNorth,
    readOnly: true,
    className: _MapWindowModule.default.north
  }), /*#__PURE__*/_react.default.createElement(_inputElements.Input, {
    type: "text",
    value: coordEast,
    readOnly: true,
    className: _MapWindowModule.default.east
  }), /*#__PURE__*/_react.default.createElement(_inputElements.Input, {
    type: "text",
    value: pinText,
    className: _MapWindowModule.default.name,
    onChange: function onChange(event) {
      return setPinText(event.target.value);
    }
  }), /*#__PURE__*/_react.default.createElement(_Button.default, {
    type: _EButtonType.default.MM_PEN,
    className: _MapWindowModule.default.addBtn
  }), /*#__PURE__*/_react.default.createElement(_Button.default, {
    type: _EButtonType.default.MM_ERASER,
    className: _MapWindowModule.default.eraseBtn
  })));
}